// @flow
import type { IConstraintModel } from "../../types";

/**
 */
class PasswordConfirmConstraint implements IConstraintModel {
  _otherPasswordLabel: string;
  _otherPasswordValue: string;

  /**
   */
  constructor(otherPasswordValue: string, otherPasswordLabel: string) {
    this._otherPasswordLabel = otherPasswordLabel;
    this._otherPasswordValue = otherPasswordValue;
  }

  /**
   */
  get id(): string {
    return "Constraint.Password.ConfirmMismatch";
  }

  /**
   */
  get otherPasswordLabel(): string {
    return this._otherPasswordLabel;
  }

  /**
   */
  get otherPasswordValue(): string {
    return this._otherPasswordValue;
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): string {
    return "Must match ${other} field"; // NOSONAR
  }

  /**
   */
  get parameters(): { other: string } {
    return {
      other: this.otherPasswordLabel,
    };
  }

  /**
   */
  validate(value: string): boolean {
    return value === this.otherPasswordValue;
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default PasswordConfirmConstraint;
